import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store';
import { ENUM_BONUS_LABEL, ENUM_CUS_EVENT } from '../../../enums/enums';
import { API_GROUP, API_USER } from '../../../api/user';
import { dispatchCusEvent, getOnlyData } from '../../../utils';
import useToast from '../../useToast';
import dayjs from 'dayjs';

export default function useEditFreespin(groupId) {
  const type = ENUM_BONUS_LABEL.freespin;
  const { successToast, errorToast } = useToast();
  const bonusFreespin = useAppSelector((state) => state.user.bonus?.[groupId]?.[type]) || [];
  const group = useAppSelector((state) => state.user.group.hash?.[groupId]);

  const [updateSubgroups, setUpdateSubgroups] = useState(false);
  const defaultCurrency = group?.currency;
  const defaultCurrencyFs = {
    enabled: false,
    name: '',
    currency: defaultCurrency,
    activated: getOnlyData(dayjs(), '00:00:00'),
    expired: getOnlyData(dayjs().add(7, 'day'), '23:59:59'),
    status: 'active',
    updateLocked: false,
    campaigns: []
  };

  const [currentFs, setCurrentFs] = useState(defaultCurrencyFs);

  const fsEnable = currentFs?.enabled;
  const fsName = currentFs?.name;
  const fsCurrency = currentFs?.currency;
  const fsActivated = currentFs?.activated;
  const fsExpired = currentFs?.expired;
  const toDeposit = currentFs?.toDeposit;
  const lockSetting = currentFs?.updateLocked;
  const fsCampaigns = currentFs?.campaigns || [];

  const saveDisabled = !(currentFs?.name && fsCampaigns.length);

  const changeDeposit = () => setCurrentFs((prev) => ({ ...prev, toDeposit: !toDeposit }));
  const changeEnable = () => setCurrentFs((prev) => ({ ...prev, enabled: !fsEnable }));
  const changeSubgroup = () => setUpdateSubgroups((prev) => !prev);
  const changeLockSetting = () => setCurrentFs((p) => ({ ...p, updateLocked: !lockSetting }));
  const changeFsName = (val) => setCurrentFs((p) => ({ ...p, name: val }));
  const changeFsActivated = (val) => setCurrentFs((p) => ({ ...p, activated: val }));
  const changeFsExpired = (val) => setCurrentFs((p) => ({ ...p, expired: val }));
  const changeFsCurrency = (val) => setCurrentFs((p) => ({ ...p, currency: val }));

  const addNewCampaign = ({ campaignId, minDeposit, maxDeposit }) => {
    setCurrentFs((prev) => {
      const newFreespin = JSON.parse(JSON.stringify(prev));
      if (!newFreespin?.campaigns) newFreespin.campaigns = [];
      newFreespin.campaigns.push({ campaignId, minDeposit, maxDeposit });

      return newFreespin;
    });
  };

  const deleteCampaign = (delIndx) => {
    setCurrentFs((prev) => {
      const newFreespin = JSON.parse(JSON.stringify(prev));
      const newCampaign = newFreespin.campaigns.filter((_, indx) => indx != delIndx);
      newFreespin.campaigns = newCampaign;

      return newFreespin;
    });
  };

  const deleteBonus = (bonusId) => {
    API_GROUP.bonus
      .delete(bonusId)
      .then((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
      })
      .catch(console.error);
  };

  const onSave = () => {
    if (!fsName) {
      errorToast('Enter a name for the bonus');
      return;
    }
    if (!fsCampaigns.length) {
      errorToast('Add a freespins template to the bonus');
      return;
    }

    const updateData = {
      groupId: +groupId,
      updateSubgroups,
      bonusLabel: type,
      bonusData: currentFs
    };

    API_USER.group.bonus
      .update(updateData)
      .then((e) => {
        dispatchCusEvent(ENUM_CUS_EVENT.getBonusList, { groupId });
        successToast('Information updated successfully');
        setCurrentFs(defaultCurrencyFs);
      })
      .catch(console.error);
  };

  return {
    fsEnable,
    fsName,
    fsCurrency,
    fsActivated,
    fsExpired,
    lockSetting,
    updateSubgroups,
    fsCampaigns,
    bonusFreespin,
    saveDisabled,
    toDeposit,
    changeDeposit,
    changeFsCurrency,
    changeFsName,
    changeFsActivated,
    changeFsExpired,
    changeSubgroup,
    changeLockSetting,
    changeEnable,
    addNewCampaign,
    deleteCampaign,
    deleteBonus,
    onSave
  };
}
